function inViewport(target, callback, options = {}) {

    let elem = document.querySelector(target);

    // if not exists
    if (elem == null) {
        return;
    }

    return new IntersectionObserver(entries => {
        entries.forEach(entry => callback(entry));
    }, options).observe(elem);
}

document.addEventListener('DOMContentLoaded', function () {

    let elements = {
        header : document.querySelector('.header')
    };

    inViewport('#js-owl', target => {
        
        if (target.isIntersecting) {
            elements.header.classList.add('header--white')
        } else {
            elements.header.classList.remove('header--white')
        }
    });


});